import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';
import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import { i18nInboxCommonService } from '@wix/inbox-common';
import i18n from '../../i18n';
import wix from '../wix';
import { fedopsLogger, LoadingPhase } from '../fedopsLogger';
import { loadingScheduler } from '../loading-scheduler';
import { wrapWithEnvironment } from './wrapper';
import { extractSiteData } from '../site-data';
import { siteDataFromSiteJson } from '../site-json';
import { loadChat } from './chat-loader';
import * as biLogger from '../biLogger';
import { initSentry } from '../sentry-integration';

fedopsLogger.init({ appName: 'chat-widget' });

const staticsBaseUrl = window.__STATICS_BASE_URL__;
const {
  publicVisibility,
  editorVisibility,
  chatOnboarded,
  businessChatEnabled,
  socialChatEnabled,
} = window.__SETTINGS__;
const experiments = window.__EXPERIMENTS__;
const chatInitResult = window.__CHAT_INIT_RESULT__;
const isLcfMandatory =
  window.__IS_LCF_MANDATORY__ === undefined
    ? { isMandatory: false, isContact: false }
    : window.__IS_LCF_MANDATORY__;
const siteJson = window.__SITE_JSON__;
const widgetMode = window.__WIDGET_MODE__;
const unpkgUrl = window.__UNPKG_URL__;
const locale = window.__SITE_LANGUAGE__;
const viewMode = wix.getViewMode();
const deviceType = wix.getDeviceType();
const visibilitySettings = {
  publicVisibility,
  editorVisibility,
  chatOnboarded,
};

const isBranded = chatInitResult
  ? chatInitResult.isBranded
  : 'No Chat Init Result';
initSentry(staticsBaseUrl, {
  userId: wix.getUid() || wix.getAid(),
  widgetMode,
  viewMode,
  deviceType,
  locale,
  isBranded,
});

i18nInboxCommonService.i18n({ locale });
wixAxiosConfig(axios, { baseURL: '/' });
const i18nData = i18n({ locale, baseUrl: staticsBaseUrl });

biLogger.initLogger({
  instanceId: wix.getInstanceId(),
  biToken: wix.getBiToken(),
  visitorId: wix.getAid(),
  viewMode,
  isSocial: socialChatEnabled,
  isBusiness: businessChatEnabled,
});

const urlParams = new URLSearchParams(window.location.search);
const disableAutoMessages = urlParams.has('disableAutoMessages');

const siteData = siteDataFromSiteJson(siteJson);
const initialDataFromSiteData = extractSiteData(siteData, experiments);

const initialState = {
  visibilitySettings,
  viewMode,
  locale,
  deviceType,
  chatInitResult,
  businessChatEnabled,
  socialChatEnabled,
  isLcfMandatory,
  widgetMode,
  disableAutoMessages,
  ...initialDataFromSiteData,
};

fedopsLogger.appLoadingPhaseStart(LoadingPhase.Bootstrap);

export const init = (component: React.ComponentClass) => {
  const environment = {
    i18n: i18nData,
    experiments,
    initialState,
  };

  void loadingScheduler.onReadyToPaint().then(() => {
    fedopsLogger.appLoadingPhaseStart(LoadingPhase.Paint);

    ReactDOM.render(
      wrapWithEnvironment(environment)(React.createElement(component)),
      document.getElementById('root'),
    );

    loadChat({ widgetMode, unpkgUrl });
  });

  loadingScheduler.triggerPaint();
};
